import { render } from "./TransactionHistoryTable.vue?vue&type=template&id=e2496462&scoped=true"
import script from "./TransactionHistoryTable.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryTable.vue?vue&type=script&lang=js"

import "./TransactionHistoryTable.vue?vue&type=style&index=0&id=e2496462&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2496462"]])

export default __exports__